






























































































































































import { Component, Vue } from 'vue-property-decorator'

import Card from '@/components/layouts/Card.vue'
import DisabledCard from '@/components/layouts/DisabledCard.vue'

import { security } from '@/store/modules/security'
import { AuthCardInfo } from '@/api'

import { cards } from '@/store/modules/cards'

import { mock } from '@/tools'

import { noValue } from '@/filters/no-value'
import EmptyMessage from '@/components/lib/EmptyMessage.vue'

type CardStatus = {
  name: string
  color: string
  nextStatus?: number
  btnText?: string
  additionalVerification: boolean
  additionalVerificationTitle?: string
  additionalVerificationText?: string
  additionalVerificationSuccess?: string
  additionalVerificationCancel?: string
  colorCard?: boolean
}

export const cardStatus: Record<number, CardStatus> = {
  5: {
    name: 'Карта активна',
    color: 'success',
    additionalVerification: true,
    nextStatus: 6,
    btnText: 'Отключить',
    additionalVerificationTitle: 'Отключение карты',
    additionalVerificationText: `
     Отключив карту, вы потеряете доступ к возможностям Карты Колымчанина. </br>

     Вы сможете подключить эту или иную карту «Мир» повторно </br>

    Отключить карту?
    `,
    additionalVerificationSuccess: 'Отключить карту',
    additionalVerificationCancel: 'Не отключать',
  },
  6: {
    name: 'Карта отключена',
    color: 'red darken-2',
    additionalVerification: false,
    nextStatus: 5,
    btnText: 'Подключить снова',
  },
}

@Component({
  components: { Card, DisabledCard, EmptyMessage },
  filters: { noValue },
})
class MainCardsView extends Vue {
  cardsModule = cards.context(this.$store)
  securityModule = security.context(this.$store)

  cardStatus = cardStatus

  isLoadingConnect = false
  isLoadingChangeStatusQR: string = null

  isOpenVerificationDialogQR: string = null

  qrPDFLink = `${process.env.API_PATH}/user/qr`
  qrLink = `${process.env.API_PATH}/claims/cardQr?qrData=`

  async created() {
    await this.cardsModule.actions.getCardList().catch(mock)
  }

  async checkCardsActive() {
    this.isLoadingConnect = true
    await this.$router.push({ name: 'connect' }).catch(mock)
    this.isLoadingConnect = false
  }

  submitChangeStatus(card: AuthCardInfo) {
    if (this.cardStatus[card.status].additionalVerification) {
      this.isOpenVerificationDialogQR = card.cardUuid
      return
    }

    this.changeCardStatus(card)
  }

  async changeCardStatus(card: AuthCardInfo) {
    this.isLoadingChangeStatusQR = card.cardUuid

    await this.cardsModule.actions
      .changeCardStatus({
        status: this.cardStatus[card.status].nextStatus,
        cardUuid: card.cardUuid,
      })
      .catch(mock)

    this.isLoadingChangeStatusQR = null
    this.isOpenVerificationDialogQR = null
  }
}

export default MainCardsView
